import IListFilter from "@/models/IListFilter";
import {CompanyType, EmploymentType, Gender, UserState} from "@/helpers/constants";
import {isEmpty} from "@/helpers/functions_asi";

export default class UserListFilter implements IListFilter {

	private static readonly defaultStateFilter = [UserState.active];
	private readonly defaultStateFilterInternal: UserState[] = [];

	public includeIds: string[] = [];
	public fulltext: string | null = null;

	public states: UserState[] = [];
	public username: string | null = null;
	public firstname: string | null = null;
	public lastname: string | null = null;
	public genders: Gender[] = [];
	public employmentTypes: EmploymentType[] = [];
	public addressSummary: string | null = null;
	public notes: string | null = null;
	public companyName: string | null = null;
	public companyTypes: CompanyType[] = [];

	public constructor(defaultStateFilter: UserState[] | null = null) {
		this.defaultStateFilterInternal = defaultStateFilter === null ? UserListFilter.defaultStateFilter : defaultStateFilter;
		this.states = this.defaultStateFilterInternal;
	}

	public clear(): void {
		this.fulltext = null;
		this.states = this.defaultStateFilterInternal;
		this.username = null;
		this.firstname = null;
		this.lastname = null;
		this.genders = [];
		this.employmentTypes = [];
		this.addressSummary = null;
		this.notes = null;
		this.companyName = null;
		this.companyTypes = [];
	}

	public hasFilter(): boolean {
		if (this.states.length !== this.defaultStateFilterInternal.length) {
			return true;
		}

		for (let i = 0; i < this.states.length; i++) {
			if (!this.defaultStateFilterInternal.includes(this.states[i])) {
				return true;
			}
		}

		return !isEmpty(this.fulltext) || !isEmpty(this.username)
			|| !isEmpty(this.firstname) || !isEmpty(this.lastname)
			|| this.genders.length > 0 || this.employmentTypes.length > 0
			|| !isEmpty(this.addressSummary) || !isEmpty(this.notes)
			|| !isEmpty(this.companyName) || this.companyTypes.length > 0;
	}

}
